import { Grid } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import { withStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import { PLAN_NAMES } from "../../../../constants/planNames";

import "./coverageGrid.css";

/* eslint-disable react/prop-types */
const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	checked: {}
	// eslint-disable-next-line
})((props) => <Checkbox color="default" {...props} />);

const CoverageGrid = ({ planDetails, coverageType, columns, planName }) => {
	// const { coverage, employer_contribution } = planDetails;

	// console.log("best", coverage);
	// console.log("Object.entries(coverage) -->", Object.entries(coverage));
	// console.log("coveragedetails ->", coverageDetails);

	const orderOfKeys = [
		"active",
		"premium_type",
		"weekly_premium",
		"weekly_maximum_premium",
		"weekly_minimum_premium",
		"monthly_premium",
		"monthly_maximum_premium",
		"monthly_minimum_premium"
	];

	return (
		<div className="coverage">
			<div className="coverage-details">
				<Grid container justifyContent="center" className="column-header-row">
					{/* {columns.map((column, index) => {
						return column === "Premium Type" && coverageType === "employers_contribution" ? (
							""
						) : (
							<Grid
								item
								xl={columns.length > 6 ? (index <= 2 ? 1 : 2) : 3}
								lg={columns.length > 6 ? (index <= 2 ? 1 : 2) : 3}
								key={index}
								className={index === columns.length - 1 ? " " : "column-header-container"}
								style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
							>
								<div style={{ display: "inline-flex" }}>
									<div className="column-header ">{column}</div>
								</div>
							</Grid>
						);
					})} */}
					{columns.map((column, index) => (
						<Grid
							item
							xl={columns.length > 6 ? (index <= 2 ? 1 : 2) : 3}
							lg={columns.length > 6 ? (index <= 2 ? 1 : 2) : 3}
							key={index}
							className={index === columns.length - 1 ? " " : "column-header-container"}
							style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
						>
							<div style={{ display: "inline-flex" }}>
								<div className="column-header">{column}</div>
							</div>
						</Grid>
					))}
					<div className="column-bottom-border"></div>
					{planDetails &&
						Object.entries(planDetails).map(([coverageKey, coverageDetails], index) => {
							console.log("coverageDetails planDetailsPopOverData", coverageKey, coverageDetails);
							return coverageType === "employers_contribution" ? (
								<Grid container justifyContent="center" className="column-item-row" key={index}>
									<Grid
										item
										xl={columns.length > 6 ? 1 : 3}
										lg={columns.length > 6 ? 1 : 3}
										key={index}
										className={index === columns.length - 1 ? "" : "column-item-container"}
										style={{
											flex: 1,
											display: "flex",
											alignItems: "center",
											justifyContent: "center"
										}}
									>
										<div style={{ display: "inline-flex" }}>
											{/* {planName === "group_short_term_disability" && coverageKey === "EE" ? (
											<div className="column-item">{coverageKey}</div>
										) : ( */}
											<div className="column-item">
												{(coverageKey[0].toUpperCase() + coverageKey.slice(1)).replace(
													/_/g,
													" "
												)}
											</div>
										</div>
									</Grid>

									{Object.entries(coverageDetails)
										.sort((a, b) => orderOfKeys.indexOf(a[0]) - orderOfKeys.indexOf(b[0]))
										.map(([key, value], index) => (
											<Grid
												item
												xl={columns.length > 6 ? (index <= 1 ? 1 : 2) : 3}
												lg={columns.length > 6 ? (index <= 1 ? 1 : 2) : 3}
												key={index}
												className={index === columns.length - 1 ? "" : "column-item-container"}
												style={{
													flex: 1,
													display: "flex",
													alignItems: "center",
													justifyContent: "center"
												}}
											>
												<div style={{ display: "inline-flex" }}>
													<div className="column-item" style={{ padding: "0px 5px" }}>
														{key === "active" ? (
															<GreenCheckbox checked={value} name={key} disabled />
														) : (
															<input
																name={key}
																value={coverageDetails[key]}
																style={{ width: "100%" }}
																disabled
															/>
														)}
													</div>
												</div>
											</Grid>
										))}
								</Grid>
							) : (
								""
							);
						})}
				</Grid>
			</div>
		</div>
	);
};

export default CoverageGrid;
